import React, { useState, useEffect } from 'react';
import './App.css';
import { downloadVCard, getCard } from './common/utils';

const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

function App() {
  const [card, setCard] = useState(null);
  const [isFlipped, setIsFlipped] = useState(false);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const path = window.location.pathname;
  let url = path.substring('/card/'.length) + '';
  url = url.replace('https:/', 'https://');
  url = decodeURIComponent(url);

  let imageUrl = url.replace('data.txt', 'front.png');
  let backImageUrl = url.replace('data.txt', 'back.png');

  useEffect(() => {
    if (!card) {
      getCard(url).then((crd) => {
        setCard(crd);
      });
    }
  }, [url, card]);

  const biztapLink = 'biztap://card/' + encodeURIComponent(url);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const rotateX = clamp((centerY - e.clientY) / 8, -20, 20);
    const rotateY = clamp((e.clientX - centerX) / 8, -20, 20);
    setTilt({ x: rotateX, y: rotateY });
  };

  const handleMouseLeave = () => {
    setTilt({ x: 0, y: 0 });
  };

  const baseRotateY = isFlipped ? 180 : 0;
  const transform = `rotateX(${tilt.x}deg) rotateY(${baseRotateY + tilt.y}deg)`;

return (
    <div className="biztap-container">
      <div className="header-row">
        <img className="header-gif" src="https://storage.googleapis.com/biztap_hosting/logo.gif" alt="" />
        <img className="image-heading" src="https://storage.googleapis.com/biztap_hosting/biztap.png" alt="Biztap" />
      </div>
      <h2 className="sub-heading">Business Card</h2>

      <div
        className="card-scene"
        onClick={() => setIsFlipped(!isFlipped)}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <div className="card-container" style={{ transform }}>
          <div className="card-front">
            <img src={imageUrl} id="biztap-card" alt="Biztap Card Front" />
          </div>
          <div className="card-back">
            <img src={backImageUrl} alt="Biztap Card Back" />
          </div>
        </div>
      </div>
      <p className="hint">Move mouse around the card to tilt • Click to flip</p>

      {card && <>
        <p className="contact-line"><span>Name:</span><span>{card.name}</span></p>
        <p className="contact-line"><span>Business:</span><span>{card.businessName}</span></p>
        <p className="contact-line"><span>Email:</span><span>{card.email}</span></p>
        <p className="contact-line"><span>Cellphone:</span><span>{card.cellphone}</span></p>
        {card.website && <p className="contact-line"><span /><a className="biztap-link-inline" href={card.website} target="_blank" rel="noreferrer">Open website: {card.website}</a></p>}
      </>}

      <p className="text"></p>
      <p className="text">Biztap (PTY) Ltd</p>
      <p className="text">Download and import this contact into your contact list!</p>

      <div className="biztap-link">
        <button className="import-btn" onClick={() => downloadVCard(url)}>Import to Contacts</button>
      </div>

    </div>
  );
}

export default App;